import React from 'react';
import './AISkeleton.css';

const AISkeleton = () => {
  return (
    <div className="ai-skeleton-container">
      {/* Header Skeleton */}
      <div className="skeleton-header">
        <div className="skeleton-line full-width h-10 mb-4"></div>
        <div className="skeleton-line half-width h-6 mb-8"></div>
      </div>

      {/* KPI Strip Skeleton */}
      <div className="skeleton-kpi-strip">
        {[1, 2, 3, 4, 5].map(i => (
          <div key={i} className="skeleton-card kpi-skeleton"></div>
        ))}
      </div>

      {/* Section Header Skeleton */}
      <div className="skeleton-section-header mt-10">
        <div className="skeleton-line short-width h-8 mb-6"></div>
      </div>

      {/* Charts Grid Skeleton */}
      <div className="skeleton-charts-grid">
        {[1, 2].map(i => (
          <div key={i} className="skeleton-card chart-skeleton"></div>
        ))}
      </div>

      {/* Section Header Skeleton */}
      <div className="skeleton-section-header mt-10">
        <div className="skeleton-line short-width h-8 mb-6"></div>
      </div>

      {/* Insights Grid Skeleton */}
      <div className="skeleton-insights-grid">
        {[1, 2, 3].map(i => (
          <div key={i} className="skeleton-card insight-skeleton"></div>
        ))}
      </div>
    </div>
  );
};

export default AISkeleton;
